import React from 'react';
import { Button, Tooltip } from '../ui';
import { HeaderAction } from './types';

interface HeaderActionsProps {
  actions: HeaderAction[];
  className?: string;
}

export const HeaderActions: React.FC<HeaderActionsProps> = ({ actions, className = '' }) => {
  if (actions.length === 0) return null;
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {actions.map((action) => {
        // Si tiene componente personalizado, renderizarlo directamente
        if (action.component) {
          return <React.Fragment key={action.id}>{action.component}</React.Fragment>;
        }

        // Renderizar botón estándar
        const button = (
          <Button
            key={action.id}
            onClick={action.onClick}
            disabled={action.disabled}
            variant={action.variant}
            data-testid={`header-action-${action.id}`}
          >
            <span className="flex items-center gap-2">
              {action.icon && <span className="w-4 h-4">{action.icon}</span>}
              {action.label}
            </span>
          </Button>
        );

        if (action.tooltip) {
          return (
            <Tooltip
              key={action.id}
              trigger={
                // Button wrapper to ensure tooltip works on disabled buttons if needed,
                // though shadcn tooltip trigger usually works on child asChild.
                // Actually Tooltip component uses asChild on TooltipTrigger.
                <div>{button}</div>
              }
              content={action.tooltip}
            />
          );
        }

        return button;
      })}
    </div>
  );
};
